import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { useArticleContent } from '@/hooks/useArticleContent';

export default function Footer() {
  const { t } = useTranslation();
  const guideContent = useArticleContent('usfans-spreadsheet-guide');

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{t('nav.brand')}</span>
            </Link>
            <p className="mt-4 max-w-md text-sm text-foreground-600 leading-relaxed">{t('footer.tagline')}</p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('footer.store')}
              <i className="ri-arrow-right-up-line" />
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/#categories" className="cursor-pointer">{t('footer.explore')}</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t(cat.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/article/usfans-spreadsheet-guide" className="cursor-pointer">{t('footer.resources')}</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/article/usfans-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                  {guideContent.title}
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                  {t('nav.home')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs text-foreground-500 leading-relaxed">{t('footer.disclaimer')}</p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} usfanslink.makeup. {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}